import Base from './Base';

class Client extends Base {
  constructor() {
    super();

    this.id = 5;
    this.name = 'client';
    this.searchQuery = 'client';
    this.title = 'Booking Details';
  }

  getDefaultData() {
    return {
      stepId: this.id,
      isHidden: false,
    };
  }

  resetOptions({ client }) { // remove the func
    return { client };
  }
}

export default Client;

